import React from 'react';
import { Box, Switch, Tooltip, Typography } from '@mui/material';

/**
 * Static or dynamic, the same control in both builders. The value is the flow's own (saved with
 * it), so switching between the canvas and the assistant never shows two different answers.
 *
 * A small switch and the current type, rather than two buttons and a "Flow type:" label: it sits
 * in toolbars that are short of room, and the tooltip says what the two types mean.
 */
const FlowTypeControl = ({ value, onChange, disabled = false }) => {
  const dynamic = value === 'DYNAMIC';
  return (
    <Tooltip
      title={
        'Static: everything the customer sees is in the flow itself. Dynamic: the flow looks '
        + 'things up while the customer fills it in, such as live booking times, or your own '
        + 'server connected in Connections.'
      }
    >
      <Box
        component="label"
        role="group"
        aria-label="Flow type"
        sx={{
          display: 'flex', alignItems: 'center', flexShrink: 0,
          cursor: disabled ? 'default' : 'pointer',
        }}
      >
        <Switch
          size="small"
          checked={dynamic}
          disabled={disabled}
          onChange={(event) => onChange(event.target.checked ? 'DYNAMIC' : 'STATIC')}
          inputProps={{ role: 'switch', 'aria-label': 'Dynamic flow' }}
        />
        <Typography
          variant="caption"
          color={disabled ? 'text.disabled' : 'text.secondary'}
          sx={{ fontWeight: 500, minWidth: 48 }}
        >
          {dynamic ? 'Dynamic' : 'Static'}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default FlowTypeControl;
